import { BufferControllerEvents } from '@bufferController/BufferController.events';
import { IBufferMetrics } from '@bufferController/BufferMetrics/IBufferMetrics';
import { TargetBufferEvents } from '@bufferController/PlaybackSpeedController/TargetBuffer.events';
import { ITargetBufferIncreaserConfig } from '@bufferController/PlaybackSpeedController/TargetBufferIncreaser/TargetBufferIncreaser.config';
import { ConfigConsumer } from '@configProvider/ConfigConsumer';
import { EDebuggableModuleState, IDebbugable, TDebuggableAdditionalInfo } from '@customTypes/common';
import { TEventBus } from '@eventBus/EventBus';
import bind from '@utils/decorators/bind';

export class TargetBufferIncreaser extends ConfigConsumer<ITargetBufferIncreaserConfig> implements IDebbugable {
  public state: EDebuggableModuleState = EDebuggableModuleState.OK;
  public status: string = 'Idle';
  public groups: string[] = ['PlaybackSpeed'];

  private _hasFallenBelowLine: boolean = true;
  private readonly _onBufferMetricsAvailableListener: string;

  constructor(eventBus: TEventBus) {
    super('targetBufferIncreaser', eventBus);

    this._onBufferMetricsAvailableListener = this._eventBus.subscribe(
      BufferControllerEvents.bufferMetricsAvailable,
      this._onBufferMetricsAvailable,
    );
  }

  @bind
  public destroy(): void {
    super.destroy();
    this._eventBus.unsubscribe(this._onBufferMetricsAvailableListener);
  }

  public _handleConfigUpdated(): void {}

  @bind
  private _onBufferMetricsAvailable(metrics: IBufferMetrics): void {
    if (this._hasFallenBelowLine) {
      if (metrics.bufferAmountWithoutGaps * 1000 >= this.config.bufferAmountThreshold) {
        this._hasFallenBelowLine = false;
      }

      return;
    }

    if (metrics.bufferAmountWithoutGaps * 1000 < this.config.bufferAmountToIncrease) {
      this._hasFallenBelowLine = true;
      this._eventBus.publish(TargetBufferEvents.targetBufferIncreaseRequested, {});
    }
  }

  get additionalInfo(): TDebuggableAdditionalInfo {
    return {
      hasFallenBelowLine: this._hasFallenBelowLine,
    };
  }
}
